module.exports = __webpack_public_path__ + "media/PR onebox.98e07011.mp4";